// 客服相关翻译
export default {
  title: "联系客服",
  description: "如需联系客服，请扫一扫下方二维码添加客服。",
  wechatPublic: "微信公众号",
  wechatCustomer: "微信客服",
  loading: "拼命加载中",
  contactButton: "联系客服",
};
